"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GoogleAnalytics = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
function GoogleAnalytics() {
    const gaMeasurementId = process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID;
    const gtmDomain = process.env.NEXT_PUBLIC_GTM_DOMAIN;
    if (!gaMeasurementId) {
        return null;
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("script", { async: true, src: `https://${gtmDomain}/gtag/js?id=${gaMeasurementId}` }),
        react_1.default.createElement("script", { dangerouslySetInnerHTML: {
                __html: `
              window.dataLayer = window.dataLayer || [];
              function gtag(){dataLayer.push(arguments);}
              gtag('js', new Date());
            
              gtag('config', '${gaMeasurementId}', {
                 page_path: window.location.pathname,
                 transport_url: 'https://${gtmDomain}',
                 first_party_collection: true
              });
          `,
            } })));
}
exports.GoogleAnalytics = GoogleAnalytics;
//# sourceMappingURL=GoogleAnalytics.js.map